export const TIME_FORMAT_OPTIONS = {
    TwelveHours: 'ampm',
    TwentyFourHours: '24h',
}